'use strict';

// Constructor
var SectionLandingBanner = function () {
    // Vertical align the text in the container
    $('.section_main_banner .inner').flexVerticalCenter();
    $('.section_secondary_banner .inner').flexVerticalCenter();
    $('.paragraph--type--promotional-banner .inner').flexVerticalCenter();

    // Add active class to animate the banner
    setTimeout(function () {
        $('.section_main_banner').addClass('active');
        $('.section_main_banner .text').addClass('active');
        $('.section_secondary_banner').addClass('active');
        $('.section_secondary_banner .text').addClass('active');
        $('.paragraph--type--promotional-banner').addClass('active');
        $('.paragraph--type--promotional-banner .text').addClass('active');
    }, 20);
    
    // If banner text height to too tall then adjust the main banner height 
    if ($('.paragraph--type--promotional-banner .inner').height() > $('.paragraph--type--promotional-banner').height()) {
        $('.paragraph--type--promotional-banner .spf-image-outer').height($('.paragraph--type--promotional-banner .inner').height() + 80);
    }
};

module.exports = SectionLandingBanner;
